module.exports = __webpack_public_path__ + "img/marker-not-delivered.b304f9c9.svg";